'use strict';

var cssVendorPrefix;

module.exports = function() {

  if (cssVendorPrefix) return cssVendorPrefix;

  var styles = window.getComputedStyle(document.documentElement, '');
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1];

  return cssVendorPrefix = '-' + pre + '-';
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/domkit/getVendorPrefix.js
 ** module id = ./node_modules/domkit/getVendorPrefix.js
 ** module chunks = 0
 **/